import React, { useState } from 'react';

import CustomDashboardMap from '../../../shared-components/custom-dashboard-map/CustomDashboardMap';

interface DashboardMapProperties {
  filters?: {
    facilityIds: string[];
    stationIds: string[];
    deviceIds: string[];
    type: string[];
  };
}

/**
 * Map component to station location
 */
function DashboardMap({ filters }: DashboardMapProperties) {
  const [showCards, setShowCards] = useState<boolean>(true);

  return (
    <div
      className="dashboard-map-wrap"
      onMouseLeave={() => setShowCards(true)}
      onClick={() => setShowCards(false)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          setShowCards(false);
        }
      }}
    >
      <div className="dashboard-map-container">
        <CustomDashboardMap
          filters={filters}
          showSearch
        />
        {/* Absolute background color */}
        {showCards && <div className="absolute-background" />}
      </div>
    </div>
  );
}

DashboardMap.defaultProps = {
  filters: {
    facilityIds: [],
    stationIds: [],
    deviceIds: [],
    type: ['commercial'],
  },
};

export default DashboardMap;
